export const SELECTABLE_DATE_RANGE = 30;
export const START_DATE_DIFF = 1;
